import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, watch } from 'vue';
import { useI18n } from '@/composables/use-i18n';
import { useRoute, useRouter } from 'vue-router/composables';
import { useCompareUrlState, ERouterMode } from '@/composables/use-compare-url-state';
import { useCompareInit } from '@/composables/use-compare-init';
import '@patsnap-ui/icon/assets/solid/compare.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompareHeader',
  props: {
    side: { default: 'left' }
  },
  setup(__props: any) {

const props = __props as { side: string }

const { t } = useI18n();
const {
    isSourcePatent,
    isSourceCustomText,
    isSourceCompareText,
    changeCompareMode,
} = useCompareUrlState();
const { isLoading:isCompareLoading } = useCompareInit();
const route = useRoute();
const router = useRouter();



const isSourceColum = computed(() => {
    return props.side === 'left';
})

const compareTips = computed(() => {
    return isSourceColum.value ? t('patent-view.compareView.sourceTips') : t('patent-view.compareView.targetTips');
})


// 只有处于文本对比 or 专利对比模式下，才显示按钮
const showSwitchButton = computed(() => {
    return !isCompareLoading.value && isSourceColum.value && (isSourcePatent.value || isSourceCustomText.value || isSourceCompareText.value);
})

const onChangeMode = () => {
    let mode = '';
    if (isSourcePatent.value) {
        mode = ERouterMode.EDIT_PATENT_ID;
    } else if (isSourceCustomText.value || isSourceCompareText.value) {
        mode = ERouterMode.EDIT_TEXT_ID;
    }
    changeCompareMode(mode);
}


return { __sfc: true,t, isSourcePatent, isSourceCustomText, isSourceCompareText, changeCompareMode, isCompareLoading, route, router, props, isSourceColum, compareTips, showSwitchButton, onChangeMode }
}

})